(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["premium-hero-banner"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  /* ── Scoped to this section instance ── */
  var sectionId  = '{{ section_id }}';
  var section    = document.getElementById('lhb-' + sectionId);
  if (!section) return;

  /* ══════════════════════════════════════
     1. SCROLL-REVEAL ANIMATIONS
     Uses IntersectionObserver — no deps
  ══════════════════════════════════════ */
  var animEls = section.querySelectorAll('[data-lhb-anim]');
  if (animEls.length > 0 && window.IntersectionObserver) {
    var once = '{{ s.animate_once }}' !== 'false';
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('lhb-animated');
          if (once) observer.unobserve(entry.target);
        } else if (!once) {
          entry.target.classList.remove('lhb-animated');
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -60px 0px' });

    animEls.forEach(function (el) { observer.observe(el); });
  } else {
    /* Fallback: show immediately for older browsers */
    animEls.forEach(function (el) { el.classList.add('lhb-animated'); });
  }

  /* ══════════════════════════════════════
     2. PARALLAX (CSS-based via JS scroll)
  ══════════════════════════════════════ */
  if ('{{ s.parallax }}' === 'true') {
    var bgEl  = section.querySelector('.lhb-bg');
    var ticking = false;
    function updateParallax() {
      var rect   = section.getBoundingClientRect();
      var prog   = Math.max(0, Math.min(1, (window.innerHeight - rect.top) / (window.innerHeight + rect.height)));
      var offset = (prog - 0.5) * 80;
      if (bgEl) bgEl.style.transform = 'translateY(' + offset + 'px) scale(1.1)';
      ticking = false;
    }
    window.addEventListener('scroll', function () {
      if (!ticking) {
        requestAnimationFrame(updateParallax);
        ticking = true;
      }
    }, { passive: true });
    updateParallax();
  }

  /* ══════════════════════════════════════
     3. COUNTDOWN TIMER
  ══════════════════════════════════════ */
  var cdEl = document.getElementById('lhb-countdown-' + sectionId);
  if (cdEl) {
    var target = new Date(cdEl.getAttribute('data-target'));
    if (!isNaN(target.getTime())) {
      var dEl = document.getElementById('lhb-days-'  + sectionId);
      var hEl = document.getElementById('lhb-hours-' + sectionId);
      var mEl = document.getElementById('lhb-mins-'  + sectionId);
      var sEl = document.getElementById('lhb-secs-'  + sectionId);

      function pad(n) { return String(Math.max(0, n)).padStart(2, '0'); }

      function tick() {
        var diff = target - Date.now();
        if (diff <= 0) { diff = 0; }
        var days  = Math.floor(diff / 86400000);
        var hours = Math.floor((diff % 86400000) / 3600000);
        var mins  = Math.floor((diff % 3600000)  / 60000);
        var secs  = Math.floor((diff % 60000)    / 1000);
        if (dEl) dEl.textContent = pad(days);
        if (hEl) hEl.textContent = pad(hours);
        if (mEl) mEl.textContent = pad(mins);
        if (sEl) sEl.textContent = pad(secs);
        if (diff > 0) setTimeout(tick, 1000);
      }
      tick();
    }
  }

})();

  } catch(e) { console.error(e); }
})();
})();
